import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShower, faCartShopping, faGlassMartini, faFistRaised, faRedo, faComment, faEdit, faPlusSquare, faBookAtlas, faSchoolCircleCheck, faCertificate, faHandshake, faTasks, faTrophy, faCircleQuestion, faPeopleGroup, faGlobe, faBullseye } from '@fortawesome/free-solid-svg-icons';
import './CoolEarth.css';
import coolearthAd from '../../assets/pageimages/sponsors/coolearthAd.png';

function CoolEarthHome() {

  return (
    <div className="flex flex-col min-h-screen bg-black text-white">
      <header className="bg-black text-yellow-200 border-b border-blue-400 p-4 text-center text-xl font-bold sticky top-0 z-50">
        🌍 CoolEarth : Structured Sustainability Achievement Goal Management
      </header>
      <div className="min-h-[90vh] px-4 mt-2">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 flex-wrap text-sm lg:text-mplace-items-center">
          {/* <CardLink to="/coolearth-library" icon={faGlobe} text="UN SDG 11-13-15" /> */}
          <CardLink to="/coolearth-sdg111315" icon={faGlobe} text="UN SDG 11-13-15" />
          <CardLink to="/coolearth-calculator" icon={faGlobe} text="Carbon Credit Calculator" />

          <CardLink to="/sugos/add" icon={faBullseye} text="Create Sustainable Goal" />
          <CardLink to="/coolearth-list" icon={faTasks} text="My Sustainable Goal/Target" />
          <CardLink to="/coolearth-mysugo" icon={faTrophy} text="My Achievement" />
          <CardLink to="/coolearth-mysugo" icon={faPeopleGroup} text="My Community Achievement" />
          <CardLink to="/coolearth-mysugo" icon={faHandshake} text="Sponsored Assignment" />
          <CardLink to="/rcas/add" icon={faCircleQuestion} text="My RCA" />
          <CardLink to="/povify-create" icon={faComment} text="My POV" />
          <CardLink to="/coolearth-mysugo" icon={faCertificate} text="My Eco Certificate" />
        </div>
      </div>
      <footer className="bg-black border-t border-blue-400 text-gray-400 py-4 sticky bottom-0 z-50">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-sm">© 2025 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

// CardLink Component
const CardLink = ({ to, icon, text }) => (
  <div className="bg-green-800 h-12 p-2 rounded-lg shadow-lg transition-transform transform hover:scale-105">
    <Link to={to} className="flex items-center text-sm lg:text-m text-white hover:text-yellow-300">
      <FontAwesomeIcon icon={icon} className="text-xl lg:text-xl mr-3" />
      {text}
    </Link>
  </div>
);

// CardLink Component
const CardNoLink = ({ to, icon, text }) => (
  <div className="bg-gray-300 p-2 rounded-lg shadow-lg transition-transform transform hover:scale-105">
    <Link to={to} className="flex items-center text-sm lg:text-m text-gray-700 hover:text-gray-900">
      <FontAwesomeIcon icon={icon} className="text-sm lg:text-m mr-3" />
      {text}
    </Link>
  </div>
);

export default CoolEarthHome;
